import { render, staticRenderFns } from "./UploadHistoricalStatements.vue?vue&type=template&id=2ad1a6cc&scoped=true&"
import script from "./UploadHistoricalStatements.vue?vue&type=script&lang=js&"
export * from "./UploadHistoricalStatements.vue?vue&type=script&lang=js&"
import style0 from "./UploadHistoricalStatements.vue?vue&type=style&index=0&id=2ad1a6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad1a6cc",
  null
  
)

export default component.exports